<template>
    <div class="form-group add-media">
        <nav v-if="editable">
            <ul class="actions">
                <li><a class="btn btn-primary" v-on:click.prevent="globalFunctions.toggleAddMedia('goodbad', null, 'image')"><photo />{{ language.add_type_image }}</a></li>
                <li><a class="btn btn-primary" v-on:click.prevent="globalFunctions.toggleAddMedia('goodbad', null, 'map')"><map-type /> {{ language.add_type_map }}</a></li>
                <li><a class="btn btn-primary" v-on:click.prevent="globalFunctions.toggleAddMedia('scale', null)"><scale />{{ language.add_type_scale }}</a></li>
                <li><a class="btn btn-primary" v-on:click.prevent="globalFunctions.toggleAddMedia('freetext', null)"><freetext />{{ language.add_type_freetext }}</a></li>
            </ul>
        </nav>
    </div>
</template>

<script>

import dataStore from '../../store'

import globalFunctions from '../../globalFunctions'

import Freetext from '../../svg/Freetext'

import Photo from '../../svg/Photo'

import MapType from '../../svg/MapType'

import Scale from '../../svg/Scale'

export default {

    data() {
        return {
            dataStore,
            globalFunctions
        }
    },

    inject: [ 'language', 'superadmin' ],

    components : {
        Scale,
        Freetext,
        Photo,
        MapType
    },

    computed: {
        editable: function() {
            return this.superadmin ? true : ( this.dataStore.project.allowToEdit && this.dataStore.isLoaded )
        }
    }


};
</script>
